import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AlphasearchComponent } from './alphasearch.component';

@NgModule({
    imports:[
        CommonModule,
        RouterModule,
    ],
    exports:[
        AlphasearchComponent,
    ],
    declarations:[
        AlphasearchComponent,
    ],
    providers:[
    ]
})

export class AlphasearchModule{}


// WEBPACK FOOTER //
// ./src/app/common/component/alphasearch/alphasearch.module.ts